import { Layout } from "antd";
import eventApi from "api/event";
import { NavBar } from "components/";
import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { isUserLoggedIn } from "utils";

const { Content } = Layout
export default function PublicLayout() {
    const [event, setEvent] = useState(null);

    const getEvent = async () => {
        try {
            const res = await eventApi.get();
            setEvent(res.event)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getEvent();
    }, []);

    if (isUserLoggedIn()) {
        return <Navigate to='/' />
    }

    return (
        <Layout >
            <NavBar />
            <Content className="public-page" style={{ backgroundImage: `url(${event?.imageUrl})` }}>
                <Outlet />
            </Content>
        </Layout>
    )
}